import { useT } from '../i18n';

type Props = {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
  onSubmit?: () => void;
  submitDone?: boolean;
};

export function PageNav({ page, pageCount, onChange, onSubmit, submitDone }: Props) {
  const t = useT();
  if (pageCount <= 1 && !onSubmit) return null;
  return (
    <div className="page-nav">
      <div className="page-nav-side page-nav-start">
        {onSubmit && (
          <button
            className={`submit-btn${submitDone ? ' submit-btn-done' : ''}`}
            onClick={onSubmit}
            disabled={submitDone}
          >
            {submitDone ? t('hw.sent') : t('submit.button')}
          </button>
        )}
      </div>
      <div className="page-nav-center">
        {pageCount > 1 && (
          <>
            <button
              onClick={() => onChange(Math.max(0, page - 1))}
              disabled={page === 0}
            >
              {t('nav.prev')}
            </button>
            <span className="page-indicator">
              {page + 1} / {pageCount}
            </span>
            <button
              onClick={() => onChange(Math.min(pageCount - 1, page + 1))}
              disabled={page === pageCount - 1}
            >
              {t('nav.next')}
            </button>
          </>
        )}
      </div>
      <div className="page-nav-side page-nav-end" />
    </div>
  );
}
